export const openDelay = 3000; // 3 sec

export const defaultInterval = 30 * 60 * 1000; // 30 mins
